import React from 'react';
import MainPage from '../../components/MainPage.react';

const Matching = ({ children }) => (
  <MainPage>
    <h2>BlueLabs Data Matching</h2>
    {children}
  </MainPage>
);

export default Matching;
